<template>
	<lv-base-column
		ref="column" v-bind="columnBinding">
		<template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow}">
			<link-table-cell-normal v-if="!fixedRow"
									:text="(currentPage-1)*pageSize + (rowIndex+1)"
									:data="{row,rowIndex,col,colIndex,editRow,fixedRow,}"/>
			<div class="lv-table-cell-normal lv-base-column-fixed-row-text" v-else>
				{{fixedRowText}}
			</div>
		</template>
	</lv-base-column>
</template>

<script>
	import {ColumnMixin} from "../mixins";
	import LvColumnText from "../lv-column-text";
	import LvBaseColumn from "../../table/lv-base-column";

	export default {
		name: "lv-column-index",
		components: {LvBaseColumn, LvColumnText},
		mixins: [ColumnMixin],
		props: {
			order: {default: 9999},
			page: {type: Number, default: 1},
			pageSize: {type: Number, default: 1},
			width: {type: Number, default: 30},
			placeLeft: {type: Boolean, default: true},
			sort: {type: Boolean, default: false},
			search: {type: Boolean, default: false},
			disabledFormEdit: {default: true},
			disabledBatchModify: {default: true},
			fastRender: {default: false},
			columnFilter: {default: false},                 //默认禁用列筛选
			fixedRowText: {default: '合计'},

			title: {default: '#'},
			align: {default: 'center'},
			disabledConfig: {default: true},
		},
		computed: {
			currentPage() {
				return this.page == null ? 1 : this.page
			},
		},
	}
</script>

<style lang="scss">
	.lv-base-column-fixed-row-text {
		span {
			display: inline-block;
			font-size: 12px;
			transform: scale(0.8);
			white-space: nowrap;
		}
	}
</style>
